import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { campaignNegativesQuery } from "../targets/campaign-targets-query";
import { CampaignNegativesTable } from "./CampaignNegativesTable";

interface CampaignNegativesProps {
  campaignId: string;
  renderAdGroupLink?: (adGroupId: string, name: string) => ReactNode;
}

/** Campaign-level 否定投放 tab: campaign- and ad-group-level negatives together. */
export function CampaignNegatives({ campaignId, renderAdGroupLink }: CampaignNegativesProps) {
  const query = useQuery(campaignNegativesQuery(campaignId));
  return (
    <CampaignNegativesTable
      campaignId={campaignId}
      data={query.data}
      isLoading={query.isPending}
      isFetching={query.isFetching}
      isError={query.isError}
      onRetry={() => void query.refetch()}
      renderAdGroupLink={renderAdGroupLink}
    />
  );
}
